<template>
    <div  class="accordion-item" :class="{ selected : active}" v-cloak>
        <h6 @click.prevent="active = !active" class="accordion-item-header">{{title}}</h6>
        <!-- SVG ARROW -->
        <svg @click.prevent="active = !active" class="svg-arrow">
            <use xlink:href="#svg-arrow"></use>
        </svg>
        <!-- /SVG ARROW -->
        <div v-show="active" class="accordion-item-content" @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave" @leave="leave">
            <slot />
        </div>
    </div>

</template>

<script>
    export default {
        props: [
            'title'
        ],
        data() {
            return {
                active: false,
            }
        },

        methods: {
            beforeEnter: function(el) {
                el.style.height = '0';
            },
            enter: function(el) {
                el.style.height = el.scrollHeight + 'px';
            },
            beforeLeave: function(el) {
                el.style.height = el.scrollHeight + 'px';
            },
            leave: function(el) {
                el.style.height = '0';
            }
        },
    };
</script>